import dayjs from 'dayjs'
import { InputFieldBase } from '../Fields/types'
import { FieldType } from './fieldTypeEnum'

export const getDefaultValues = (fields: InputFieldBase[]) => {
  const defaultValues: Record<string, any> = {}

  fields?.forEach(field => {
    const { fieldType, name, value } = field
    if (fieldType === FieldType.DIVIDER) return
    if (fieldType === FieldType.DATEPICKER || fieldType === FieldType.TIMEPICKER) {
      return (defaultValues[name!] = dayjs(new Date(Date.now())))
    }
    return (defaultValues[name!] = value ?? '')
  })

  return defaultValues
}
